import store from '../store';

const currencys = {
  RUB: 'rubles',
  EUR: 'euro',
};

const types = {
  PURCHASE: 'positive',
  TRANSFER: 'positive',
  PAYOUT: 'negative',
  TRANSFEROUT: 'negative',
};

const iconStyle = {
  TRANSFER: 'transfer',
  PAYOUT: 'withdrawal',
  PURCHASE: 'order',
  BILL: 'bill',
};

export const getCurrencyClass = {
  methods: {
    getCurrencyClass(value) {
      return currencys[value];
    },
  },
};

export const getTypeClass = {
  methods: {
    getTypeClass(value) {
      return types[value];
    },
  },
};

export const getIconStyle = {
  methods: {
    getIconStyle(value) {
      return iconStyle[value];
    },
  },
};

// TODO: @danealton этого тут быть не должно, общие миксины не должны содержать бизнес логики
export const tryAgain = {
  methods: {
    tryAgain() {
      const routeName = store.state.TRANSACTION.billId ? 'BillAmount' : 'PaymentProject';

      const params = {
        name: routeName,
        params: { id: store.state.TRANSACTION_KEY },
      };

      if (Object.keys(store.state.TRANSACTION_QUERY).length) {
        params.query = store.state.TRANSACTION_QUERY;
      }

      this.$router.push(params);
    },
  },
};

export const luhn = {
  methods: {
    luhn(value) {
      let ch = 0;
      const num = String(value).replace(/\D/g, '');
      const isOdd = num.length % 2 !== 0;

      if (num === '') return false;

      for (let i = 0; i < num.length; i++) {
        let n = parseInt(num[i], 10);

        ch += (isOdd | 0) === (i % 2) && (n *= 2) > 9 ? (n - 9) : n;
      }

      return (ch % 10) === 0;
    },
  },
};

export const prettyCardNumber = {
  methods: {
    prettyCardNumber(cardNumber, creditCardType) {
      if (!Object.keys(creditCardType).length) return cardNumber;

      const offsets = [].concat(0, creditCardType.gaps, cardNumber.length);
      const components = [];

      for (let i = 0; offsets[i] < cardNumber.length; i++) {
        const start = offsets[i];
        const end = Math.min(offsets[i + 1], cardNumber.length);
        components.push(cardNumber.substring(start, end));
      }

      return components.join(' ');
    },
  },
};

export const copyLink = {
  methods: {
    copyLink(node) {
      if (window.getSelection) {
        if (window.getSelection().empty) { // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) { // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) { // IE?
        document.selection.empty();
      }

      if (document.selection) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select().createTextRange();
        document.execCommand('copy');
      } else if (window.getSelection) {
        const range = document.createRange();
        range.selectNode(node);
        window.getSelection().addRange(range);
        document.execCommand('copy');
      }
    },
  },
};

let _timer = null;
export const debounce = {
  methods: {
    debounce(fn, delay) {
      if (_timer) clearTimeout(_timer);
      _timer = setTimeout(() => fn(), delay);
    },
  },
};
